/**
 * Shotokan Black Dragon — Titres & Reconnaissances (mock/local Phase 1).
 * Aucun titre, document ou reconnaissance officielle inventé.
 * Référentiel interne — à valider selon documents d'autorité fournis.
 */

export const INTERNAL_REFERRAL_FR =
  "Référentiel interne Shotokan Black Dragon — à valider selon les documents d'autorité fournis.";
export const INTERNAL_REFERRAL_EN =
  "Internal Shotokan Black Dragon reference — to be validated against supplied authority documents.";

/** @type {import('./types.js').MartialTitle[]} */
export const demoMartialTitles = [
  {
    id: "title-sempai",
    nom: "[DÉMO] Sempai",
    nom_japonais: "先輩",
    type: "enseignement",
    niveau: 1,
    grade_minimum: "1er dan [À VALIDER]",
    annees_pratique_minimum: 3,
    annees_enseignement_minimum: 1,
    documents_requis: "Fiche expérience, recommandation Sensei — démo.",
    description: "Assistant senior — critères à confirmer avec le responsable.",
    statut: "demo",
    notes_validation: "Référentiel interne — pas de reconnaissance externe.",
    demo: true,
  },
  {
    id: "title-sensei",
    nom: "[DÉMO] Sensei",
    nom_japonais: "先生",
    type: "enseignement",
    niveau: 2,
    grade_minimum: "2e dan [À VALIDER]",
    annees_pratique_minimum: 8,
    annees_enseignement_minimum: 3,
    documents_requis: "Portfolio enseignement, recommandations, entretien — démo.",
    description: "Enseignant reconnu — titre distinct du rôle applicatif Sensei.",
    statut: "a_valider",
    notes_validation: "Critères à valider avec documents d'autorité.",
    demo: true,
  },
  {
    id: "title-shihan",
    nom: "[DÉMO] Shihan",
    nom_japonais: "師範",
    type: "reconnaissance",
    niveau: 3,
    grade_minimum: "4e dan [À VALIDER]",
    annees_pratique_minimum: 15,
    annees_enseignement_minimum: 8,
    documents_requis: "Dossier complet, contribution dojo, validation autorité — démo.",
    description: "Maître instructeur — reconnaissance interne à confirmer.",
    statut: "a_valider",
    notes_validation: "Ne pas afficher comme reconnu au Japon.",
    demo: true,
  },
  {
    id: "title-renshi",
    nom: "[DÉMO] Renshi",
    nom_japonais: "錬士",
    type: "reconnaissance",
    niveau: 4,
    grade_minimum: "5e dan [À VALIDER]",
    annees_pratique_minimum: 20,
    annees_enseignement_minimum: 10,
    documents_requis: "Historique grade, contribution, documents autorité — démo.",
    description: "Titre de reconnaissance avancée — critères à confirmer.",
    statut: "a_valider",
    notes_validation: "Référentiel interne Black Dragon.",
    demo: true,
  },
  {
    id: "title-kyoshi",
    nom: "[DÉMO] Kyoshi",
    nom_japonais: "教士",
    type: "reconnaissance",
    niveau: 5,
    grade_minimum: "7e dan [À VALIDER]",
    annees_pratique_minimum: 30,
    annees_enseignement_minimum: 15,
    documents_requis: "Dossier complet, recommandations fédérales si applicable — démo.",
    description: "Enseignant émérite — futur Phase 2+.",
    statut: "futur",
    notes_validation: "Hors Phase 1 opérationnel.",
    demo: true,
  },
  {
    id: "title-hanshi",
    nom: "[DÉMO] Hanshi",
    nom_japonais: "範士",
    type: "honneur",
    niveau: 6,
    grade_minimum: "8e dan [À VALIDER]",
    annees_pratique_minimum: 40,
    annees_enseignement_minimum: 25,
    documents_requis: "Autorité compétente, documents d'attribution — démo.",
    description: "Plus haute reconnaissance enseignement — validation autorité requise.",
    statut: "futur",
    notes_validation: "Distinct du rôle Hanshi/Admin applicatif.",
    demo: true,
  },
];

/** @type {import('./types.js').TitleApplication[]} */
export const demoTitleApplications = [
  {
    id: "app-demo-sensei-01",
    candidat_id: "demo-sensei-placeholder",
    candidat_nom: "[DÉMO] Instructeur principal",
    dojo_id: "demo-dojo-01",
    titre_demande_id: "title-sensei",
    grade_actuel: "3e dan [À VALIDER]",
    annees_pratique: 12,
    annees_enseignement: 5,
    experience: "Enseignement enfants et adultes — démo.",
    contribution: "Organisation séminaires locaux — démo.",
    recommandation_par: null,
    documents: ["fiche_experience_demo.pdf", "recommandation_dojo_demo.pdf"],
    statut: "soumis",
    decision: null,
    notes_revision: "",
    date_soumission: "2026-05-15",
    date_decision: null,
    demo: true,
  },
  {
    id: "app-demo-shihan-01",
    candidat_id: "demo-instructeur-02",
    candidat_nom: "[DÉMO] Instructeur adjoint",
    dojo_id: "demo-dojo-01",
    titre_demande_id: "title-shihan",
    grade_actuel: "4e dan [À VALIDER]",
    annees_pratique: 18,
    annees_enseignement: 10,
    experience: "Direction technique groupe compétition — démo.",
    contribution: "Mentorat Sempai — démo.",
    recommandation_par: "demo-sensei-placeholder",
    documents: ["portfolio_enseignement_demo.pdf"],
    statut: "en_revision",
    decision: null,
    notes_revision: "[DÉMO] Dossier en cours de révision — documents complémentaires possibles.",
    date_soumission: "2026-04-01",
    date_decision: null,
    demo: true,
  },
  {
    id: "app-demo-renshi-01",
    candidat_id: "demo-instructeur-03",
    candidat_nom: "[DÉMO] Senior instructeur",
    dojo_id: "demo-dojo-01",
    titre_demande_id: "title-renshi",
    grade_actuel: "5e dan [À VALIDER]",
    annees_pratique: 22,
    annees_enseignement: 12,
    experience: "Enseignement multi-dojo — démo.",
    contribution: "Formation instructeurs — démo.",
    recommandation_par: null,
    documents: [],
    statut: "documents_manquants",
    decision: null,
    notes_revision: "[DÉMO] Documents d'autorité et recommandations requis.",
    date_soumission: "2026-06-01",
    date_decision: null,
    demo: true,
  },
];

/** @type {import('./types.js').TitleAuthority[]} */
export const demoTitleAuthority = [
  {
    id: "auth-demo-responsable",
    nom: "[DÉMO] Responsable Shotokan Black Dragon",
    grade: "10e dan [À VALIDER]",
    titre: "[À VALIDER]",
    source_autorite: "[DOCUMENTS À FOURNIR]",
    sejour_japon: true,
    sejour_japon_statut: "a_valider",
    documents_preuve: [],
    limites:
      "Portée d'attribution à confirmer selon documents fournis — aucune reconnaissance externe affichée comme officielle.",
    statut_validation: "en_attente_documents",
    notes:
      "Information métier : responsable rendu 10e dan après séjour/formation Japon — preuves et documents d'autorité en attente.",
    demo: true,
  },
];

/** @type {import('./types.js').TitleRegisterEntry[]} */
export const demoTitleRegister = [
  {
    id: "reg-demo-01",
    personne_id: "demo-sensei-placeholder",
    nom: "[DÉMO] Instructeur principal",
    titre_id: "title-sensei",
    titre_nom: "[DÉMO] Sensei",
    date_attribution: "2024-01-15",
    attribue_par: "auth-demo-responsable",
    statut: "a_confirmer",
    numero_registre: "SBD-DEMO-001",
    certificat_statut: "futur_pdf",
    notes: "Entrée démo — certificat PDF Phase 2+.",
    demo: true,
  },
];
